import * as AiApi from '@newfront-insurance/ai-api';

interface GeneralFeedbackReasonContract {
  readonly FEATURE_REQUEST: string;
  readonly SOMETHING_BROKE: string;
}

const feedbackApiRuntime = AiApi as typeof AiApi & {
  readonly GeneralFeedbackReason?: Partial<GeneralFeedbackReasonContract>;
  readonly NOVA_FEEDBACK_DETAIL_MAX_LENGTH?: number;
};

const generalFeedbackReason =
  'GeneralFeedbackReason' in feedbackApiRuntime ? feedbackApiRuntime.GeneralFeedbackReason : undefined;
const feedbackDetailMaxLength = feedbackApiRuntime.NOVA_FEEDBACK_DETAIL_MAX_LENGTH;

/**
 * The general-feedback exports are introduced by backend PR #11842. Keeping the
 * runtime capability check here lets this PR merge before that package release;
 * updating ai-api is then sufficient to enable the feature without duplicating
 * enum values or validation limits in the frontend.
 */
export const GENERAL_FEEDBACK_API_CONTRACT =
  typeof generalFeedbackReason?.FEATURE_REQUEST === 'string' &&
  typeof generalFeedbackReason.SOMETHING_BROKE === 'string' &&
  typeof feedbackDetailMaxLength === 'number'
    ? {
        GeneralFeedbackReason: generalFeedbackReason as GeneralFeedbackReasonContract,
        NOVA_FEEDBACK_DETAIL_MAX_LENGTH: feedbackDetailMaxLength,
      }
    : undefined;

export const NOVA_FEEDBACK_DETAIL_MAX_LENGTH = feedbackDetailMaxLength;
